import { useEffect, useState } from "react";
import "./page.css";

const API_URL = "https://irc.zentelex.com/api/users/users";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);

  // Filter states
  const [roleFilter, setRoleFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [warehouseFilter, setWarehouseFilter] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await fetch(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (res.ok) {
        setUsers(data.data);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error("Failed to fetch users", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );

    if (!confirmDelete) return;

    try {
      setDeletingId(id);
      const token = sessionStorage.getItem("token");

      const res = await fetch(`${API_URL}/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (res.ok) {
        setUsers((prev) => prev.filter((user) => user.id !== id));
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (error) {
      console.error("Delete error", error);
      alert("Something went wrong");
    } finally {
      setDeletingId(null);
    }
  };

  // Filter users before rendering
 const filteredUsers = users.filter((user) => {
  // ❌ remove admin & superadmin
  if (user.role === "admin" || user.role === "Super_admin") {
    return false;
  }

  return (
    (roleFilter ? user.role === roleFilter : true) &&
    (statusFilter ? user.status === statusFilter : true) &&
    (warehouseFilter
      ? user.warehouse_location?.toLowerCase().includes(warehouseFilter.toLowerCase())
      : true)
  );
});

  if (loading) {
    return <div className="loader">Loading users...</div>;
  }

  return (
    <div className="admin-container">
      <h2 className="page-title">User Management</h2>

      {/* Filters */}
     {/* Filters */}
<div className="filters">
  <select
    className="filter-select"
    value={roleFilter}
    onChange={(e) => setRoleFilter(e.target.value)}
  >
    <option value="">All Roles</option>
    <option value="Operations">Operations</option>
    <option value="QC">QC</option>
    <option value="Accounts">Accounts</option>
  </select>

  <select
    className="filter-select"
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
  >
    <option value="">All Status</option>
    <option value="ACTIVE">ACTIVE</option>
    <option value="INACTIVE">INACTIVE</option>
  </select>

  <input
    className="filter-input"
    type="text"
    placeholder="Warehouse"
    value={warehouseFilter}
    onChange={(e) => setWarehouseFilter(e.target.value)}
  />

  <button
    className="clear-filters"
    onClick={() => {
      setRoleFilter("");
      setStatusFilter("");
      setWarehouseFilter("");
    }}
  >
    Clear
  </button>
</div>


      <div className="table-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Emp ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Warehouse</th>
              <th>Status</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredUsers.map((user, index) => (
              <tr key={user.id}>
                <td>{index + 1}</td>
                <td>{user.emp_id}</td>
                <td className="name-cell">{user.name}</td>
                <td>{user.email}</td>
                <td>
                  <span className={`badge ${user.role.toLowerCase()}`}>{user.role}</span>
                </td>
                <td>{user.warehouse_location}</td>
                <td>
                  <span className={`badge ${user.status === "ACTIVE" ? "active" : "inactive"}`}>
                    {user.status}
                  </span>
                </td>
                <td>{new Date(user.createdAt).toLocaleDateString("en-IN")}</td>
                <td>
                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(user.id)}
                    disabled={deletingId === user.id}
                  >
                    {deletingId === user.id ? "Deleting..." : "Delete"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {filteredUsers.length === 0 && <div className="empty-state">No users found</div>}
      </div>
    </div>
  );
};

export default UserList;
